import styled from '@emotion/styled';
import { breakpoints, InternalLink } from 'gatsby-theme-apollo';

const GameGrid = styled.div`
  display: flex;
  align-items: space-between;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const GameLink = styled(InternalLink)({
  display: `flex`,
  width: `150px`,
  flexShrink: 0,
  height: `100px`,
  justifyContent: `flex-start`,
  alignItems: `center`,
  padding: `5px`
});

const GameThumbnail = styled.img`
  width: 55px;
  height: 80px;
  border-radius: 5px;
`;

const GameThumbnailName = styled.div`
`;

export default styled.div({
  padding: '0px 64px',
  position: 'relative',
  [breakpoints.md]: {
    padding: '0px 18px'
  },
  [breakpoints.sm]: {
    padding: '0px 10px'
  }
});

const GameCover = styled.div(props => ({
  flex: 1,
  flexShrink: 0,
  flexGrow: 0,
  backgroundColor: 'black',
  margin: '5px',
  position: 'relative',
  transition: 'transform 0.1s ease',
  borderRadius: props.theme.radius,
  boxSizing: 'border-box',
  border: `1px solid ${props.theme.outlineUnfocused}`,
  cursor: 'pointer',
  overflow: 'hidden',

  [`div`]: {
    height: '160px',
    width: '110px',
  },

  [`span`]: {
    width: '110px',
  },

  [`img`]: {
    overflow: 'hidden',
    height: '100%',
    width: 'auto',
  },
  
  [`:hover `]: {
    [`span`]: {
      color: 'black',
      backgroundColor: `rgba(255, 255, 255, 1)`
    },
    transform: `scale(1.05)`,
    border: `1px solid ${props.theme.outlineFocused}`,
  }
}));

const CoverTitle = styled.span`
  display: block;
  padding: 0 3px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 24px;
  transition: 'color .2s ease, background-color .2s ease',
`;

export { CoverTitle, GameGrid, GameCover, GameLink, GameThumbnail, GameThumbnailName };
